var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:_vm.className,attrs:{"role":"alert"},on:{"click":_vm.onClick}},[_c('span',[(_vm.icon)?_c('font-awesome-icon',{staticClass:"mr-3",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }